import { styled } from '../../../../modules';

function hexToRgba(hex: string, alpha: number): string {
    let c = hex.replace('#', '');
    if (c.length === 3) {
        c = c.split('').map((x) => x + x).join('');
    }
    const num = parseInt(c, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r},${g},${b},${alpha})`;
}

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 8px;
`;

export const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 28px;
    padding: 32px 24px 16px;
`;

export const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 20px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
`;

export const ProposalHeader = styled.div<{ $backgroundColor?: string; $padBottom?: number }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: ${({ $padBottom }) => `24px 24px ${$padBottom ?? 90}px`};
    background: ${({ $backgroundColor }) => `
        radial-gradient(
            circle at top left,
            ${hexToRgba($backgroundColor || '#ffffff', 0.82)} 0%,
            ${hexToRgba($backgroundColor || '#ffffff', 0.92)} 100%
        )
    `};
    min-height: 80px;
    flex-shrink: 0;
`;

export const HeaderTitle = styled.h1`
    font-size: 23px;
    font-weight: 400;
    color: #ffffff;
    margin: 0;
    line-height: 1.35;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const HeaderBodyText = styled.p`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    line-height: 1.6;
    text-align: center;

    strong {
        color: #ffffff;
        font-weight: 700;
    }
`;

export const CardWrapper = styled.div<{ $color?: string }>`
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    padding: 4px;
    margin-top: 16px;
    border-radius: 16px;
    background-color: ${({ $color }) => $color || '#ffffff'}33;
    border: 1px solid ${({ $color }) => $color || '#ffffff'};
`;

export const GlassyBadge = styled.div<{ $color?: string }>`
    position: absolute;
    top: -48px;
    right: -28px;
    width: 72px;
    height: 72px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid ${({ $color }) => hexToRgba($color || '#ffffff', 0.5)};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
`;

export const AdvantagesSection = styled.div`
    width: 100%;
    padding: 8px 24px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const AdvantagesTitle = styled.h3<{ $accentColor?: string }>`
    font-size: 18px;
    font-weight: 700;
    color: ${({ $accentColor }) => $accentColor || '#0e3573'};
    margin: 8px 0 0 0;
`;

export const AdvantageHighlight = styled.div<{ $borderColor: string; $textColor: string }>`
    background-color: transparent;
    border: 1px solid ${({ $borderColor }) => $borderColor};
    border-radius: 12px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 500;
    color: ${({ $textColor }) => $textColor};
    text-align: center;
    background-color: ${({ $borderColor }) => $borderColor}14;

    strong {
        font-weight: 700;
    }
`;

export const AdvantagesGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
`;

export const AdvantageChip = styled.div<{ $borderColor: string; $textColor: string }>`
    background-color: transparent;
    border: 1px solid ${({ $borderColor }) => $borderColor};
    border-radius: 12px;
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ $textColor }) => $textColor};
    background-color: ${({ $borderColor }) => $borderColor}14;
`;

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 180px;
    object-fit: contain;
`;

export const IntroSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    text-align: center;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 22px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.35;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const Subtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #555;
    margin: 0;
    text-align: center;
`;

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`;

export const FormFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
